import { IApplicationState } from '../../types/redux';
import { selectOffer } from './selectOffer';
import { IField, EFieldGroupName, EFieldName } from '../../types/field';

export const selectOfferFieldAvailable =
  (id: number, groupName: EFieldGroupName, name: EFieldName) => (state: IApplicationState) => {
    const { fields } = selectOffer(id)(state);
    const group: IField | undefined = fields.find(({ name }) => name === groupName);

    return !!group && group.items.includes(name);
  };
